import { Model } from "vuex-fetch-factory";

export enum Interval {
  month = 1,
  quarter = 2,
  year = 3,
  sixMonths = 4,
  twoYears = 5,
  week = 6,
}

export interface TermRaw {
  id: number;
  description: string;
  amount: number;
  price: number;
  interval: number;
}

export class TermModel implements Model<TermModel, TermRaw> {
  private id = 0;
  private description = "";
  private amount = 0;
  private price = 0;
  private interval: Interval = 0;

  public getNew(): TermModel {
    return new TermModel();
  }

  public fillModel(raw: TermRaw): this {
    this.id = raw.id;
    this.description = raw.description;
    this.amount = raw.amount;
    this.price = raw.price;
    this.interval = raw.interval;
    return this;
  }

  public getRaw(): TermRaw {
    return {
      id: this.id,
      description: this.description,
      amount: this.amount,
      price: this.price,
      interval: this.interval,
    };
  }

  public get intervalString(): string {
    switch (this.interval) {
      case Interval.month:
        return "per maand";
      case Interval.quarter:
        return "per kwartaal";
      case Interval.year:
        return "per jaar";
      case Interval.sixMonths:
        return "per half jaar";
      case Interval.twoYears:
        return "per twee jaar";
      case Interval.week:
        return "per week";
      default:
        return "";
    }
  }

  public get termTotal(): number {
    return this.amount * this.price;
  }
}
